import { Fetch } from 'lib';
import type { Watermark } from 'types';

type RequestResponses = Watermark;

const getWatermark = async () =>
  await Fetch<RequestResponses>({
    url: 'adminConfig/getWatermark',
  });

export { getWatermark };
